<template>
  <Dialog
    v-model="downErrorDialogVisible" size="small" class="downError_message">
    <div class="downError_message_dialog">
      <h5 class="downError_message_title">文件下载失败（{{ downErrorCode }}），请联系客服。</h5>
      <Button class="downError_message_btn" @click="clickContactCustom">联系客服</Button>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog/index.vue'
import Button from '@/components/Button/index.vue'

import { ClientOpenBrowser } from '@/api/clientApi'
import { customerServiceUrl } from '@/common/data'

// https://cheetahfun.feishu.cn/docs/doccnkTf42OiwuEkAUhvwjhk25f

export default {
  name: 'DownErrorTipDialog',

  components: { Dialog, Button },

  computed: {
    downErrorCode () {
      return this.$store.state.tipsDialog.downErrorCode
    },

    downErrorDialogVisible: {
      get: function () {
        const sucCode = this.$store.state.tipsDialog.downSuccessCode

        return this.downErrorCode !== sucCode
      },
      set: function () {
        this.$store.commit('tipsDialog/changeDownErrorCode')
      }
    }
  },

  methods: {
    clickContactCustom () {
      ClientOpenBrowser(customerServiceUrl)
      this.$store.commit('tipsDialog/changeDownErrorCode')
    }
  }
}
</script>

<style lang="scss" scoped>
.downError_message_dialog { position: absolute; top: 0; right: 0; bottom: 0; left: 0; padding-top: 35px; text-align: center;
  .downError_message_title { position: relative; top: 0px; font-size: 16px; font-weight: 400; color: #333; text-align: center; }
  .downError_message_btn { position: relative; top: 30px; }
}
</style>
